import { LOGOUT } from '@/utils/store/mutationTypes'
import { FETCH_USER } from '@/utils/store/actionTypes'
import { getCookieDomain } from '@/utils/cookie'

export default async function ({ store, isHMR, app }) {
  if (isHMR) {
    return
  }

  const token = app.$cookies.get('apollo-token')
  const expires = app.$cookies.get('apollo-expires')

  const onExpiredSession = () => {
    app.$cookies.remove('apollo-expires', {
      path: '/',
      domain: getCookieDomain()
    })
    app.$cookies.remove('apollo-token', {
      path: '/',
      domain: getCookieDomain()
    })

    store.commit(`auth/${LOGOUT}`)
  }

  if (token) {
    if (!expires || app.$moment.unix(expires).isBefore(new Date())) {
      onExpiredSession()

      return
    }

    if (!store.state.auth.user) {
      try {
        await store.dispatch(`auth/${FETCH_USER}`)
      } catch (error) {
        onExpiredSession()
      }
    }
  }
}
